import React from "react";
import "./status-idle-keg.scss";

const StatusIdle = () => {
  return (
    <div className="device__status--keg-idle">
      <span className="ion-ios-pint device__alert-icon" />
      <span>No active session — start a new brew</span>
    </div>
  );
};

export default StatusIdle;
